export default {
	remoteOrigin: '',
	apiPrefix: '/app/v1',
	clientType: 1,
	brandType: 1,
	clientVersion: 1,
	resource: 'https://resource.oss.yatiku.com/',
	NODE: 'development',
}



// WEBPACK FOOTER //
// ./src/constants/releaseConfig.js